"use strict";
/*
 * Created on 11 01 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author Jaroslav Sevcik
 */


var ReferencePriceConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ReferencePriceConverter, _DataObjectConverter_);

  function ReferencePriceConverter() {
    _classCallCheck(this, ReferencePriceConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ReferencePriceConverter).apply(this, arguments));
  }

  return ReferencePriceConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ReferencePriceConverter = ReferencePriceConverter;